const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

async function requestJson(url, options) {
  const res = await fetch(url, options);
  const text = await res.text();
  const data = text ? (() => { try { return JSON.parse(text); } catch { return text; } })() : null;

  if (!res.ok) {
    const message =
      (data && typeof data === 'object' && (data.message || data.error)) ||
      `Request failed (${res.status})`;
    throw new Error(message);
  }
  return data;
}

function normalizeProjectId(project) {
  if (!project) return project;
  // Keep compatibility with existing UI that expects `project.id`.
  if (project.id) return project;
  if (project._id) return { ...project, id: project._id.toString() };
  return project;
}

// Public (user-facing) projects
export const getAllProjects = async () => {
  const data = await requestJson(`${API_BASE_URL}/getallprojects`);
  const projects = data?.data ?? data ?? [];
  return projects.map(normalizeProjectId);
};

export const getFeaturedProjects = async (count = 3) => {
  const data = await requestJson(`${API_BASE_URL}/getFeaturedProjects/${count}`);
  const projects = data?.data ?? data ?? [];
  return projects.map(normalizeProjectId);
};

export const getProjectById = async (id) => {
  const data = await requestJson(`${API_BASE_URL}/getproject/${id}`);
  const project = data?.data ?? data ?? null;
  return project ? normalizeProjectId(project) : null;
};

// Admin (protected via your existing AdminLogin approach)
export const adminLogin = async ({ AdminUsername, AdminPassword }) => {
  return requestJson(`${API_BASE_URL}/AdminLogin`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ AdminUsername, AdminPassword }),
  });
};

export const getAllProjectsAdmin = async () => {
  const data = await requestJson(`${API_BASE_URL}/getallprojects/Admin`);
  const projects = data?.data ?? data ?? [];
  return projects.map(normalizeProjectId);
};

export const createProject = async (formData) => {
  // Backend should handle multipart via multer.
  const data = await requestJson(`${API_BASE_URL}/AddProject`, {
    method: 'POST',
    body: formData,
  });
  return data;
};

export const updateProject = async (id, formData) => {
  const data = await requestJson(`${API_BASE_URL}/updateProject/${id}`, {
    method: 'PUT',
    body: formData,
  });
  return data;
};

export const deleteProject = async (id) => {
  const data = await requestJson(`${API_BASE_URL}/deleteProject/${id}`, {
    method: 'DELETE',
  });
  return data;
};
